import type { ReactNode } from "react";
import { cx } from "../cx";

interface Props {
  id: string;
  title: string;
  active: boolean;
  className?: string;
  children: ReactNode;
}

export function ServiceCard({ id, title, active, className, children }: Props) {
  if (!active) return null;
  return (
    <div id={id} className={cx("nv-svc-card", className)}>
      <div className="nv-svc-head">
        <h4 className="nv-svc-title">{title}</h4>
      </div>
      <fieldset className="nv-svc-body">
        <legend className="nv-sr-only">{title}</legend>
        {children}
      </fieldset>
    </div>
  );
}
